import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { BOX_NOTECARD_STEPS } from '../../../../../redux/box-notecard-editor/box-notecard-editor.reducer';
import { selectedBoxItemsIdSelector } from '../../../../../redux/box-notecard-editor/box-notecard-editor.selectors';
import { emailForConfirmProvideLaterStepSelector } from '../../../../../redux/box-notecard-editor/box-notecard-editor.selectors-other';
import { moveToPopupStep, closeBoxNotecardEditorPopup } from '../../../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { toggleSpecialProductInBox } from '../../../../../redux/box-builder/box-builder.actions';
import { ConfirmProvideLaterStepComponent } from './confirm-step';
const mapStateToProps = createStructuredSelector({
  boxItemsId: selectedBoxItemsIdSelector,
  email: emailForConfirmProvideLaterStepSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: boxItemsId => {
    //ADD NOTECARD WITHOUT DESIGN ITEM AND UPDATE CART
    dispatch(closeBoxNotecardEditorPopup());
    dispatch(toggleSpecialProductInBox(boxItemsId, SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, {
      isNotecardPicked: true
    }));
  },
  onBack: () => {
    dispatch(moveToPopupStep(BOX_NOTECARD_STEPS.LOGO_AND_COLOR));
  }
});
export const ConfirmProvideLaterStep = connect(mapStateToProps, mapDispatchToProps)(ConfirmProvideLaterStepComponent);